import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Content } from 'rsuite';
import {
  ItemType,
  PackageType,
  InventoryTypesLabel
} from '../../../constants/inventory/InventoryTypes';
import { inventoryItemsPath, inventoryPackagesPath } from '../../Paths';
import * as PERMISSIONS from '../../../constants/permissions/inventory';
import { modifyAccess } from '../../../helpers/permission';
import AccessControl from '../../../components/AccessControl';
import AccessDenied from '../../../components/AccessDenied';
import InventoryItemForm from '../../../containers/inventory/ItemForm';
import InventoryPageLayout from '../../../containers/inventory/PageLayout';
import PageHeader from '../../../components/PageHeader';
import Breadcrumb from '../../../components/Breadcrumb';

const listPathByType = {
  [ItemType]: inventoryItemsPath,
  [PackageType]: inventoryPackagesPath
};

const permissionByType = {
  [ItemType]: PERMISSIONS.ITEM,
  [PackageType]: PERMISSIONS.PACKAGE
};

export default class CreateInventoryItem extends Component {
  static propTypes = {
    type: PropTypes.oneOf([ItemType, PackageType]).isRequired,
    onInit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { onInit } = this.props;
    onInit();
  }

  renderBreadcrumb() {
    const { type } = this.props;
    return (
      <Breadcrumb
        items={[
          {
            path: listPathByType[type],
            label: type === PackageType ? 'Packages' : 'Items'
          },
          { label: `Create ${InventoryTypesLabel[type]}` }
        ]}
      />
    );
  }

  render() {
    const { type, onSubmit } = this.props;
    return (
      <InventoryPageLayout>
        <AccessControl
          allowOnlyFor={modifyAccess(permissionByType[type])}
          fallback={<AccessDenied />}
        >
          {this.renderBreadcrumb()}
          <PageHeader title={`Create ${InventoryTypesLabel[type]}`} />
          <Content>
            <InventoryItemForm type={type} onSubmit={onSubmit} />
          </Content>
        </AccessControl>
      </InventoryPageLayout>
    );
  }
}
